module.exports = __webpack_public_path__ + "static/media/patch.a1e0b849.svg";